import styled from "styled-components";
export const ReportsWrap = styled.div`
    .textWrap {
        display: flex;
        align-items: center;
        gap: 10px;
        .image-wrapper {
            max-width: 30px;
            height: 30px;
            img {
                border-radius: 50%;
                width: 100%;
                height: 30px;
            }
        }
    }
    .status {
        border-radius: 30px;
        padding: 7px 10px;
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        &.completed {
            color: rgba(39, 196, 83, 1);
            background: rgba(39, 196, 83, 0.2);
        }
        &.pending {
            color: rgba(245, 126, 42, 1);
            background: rgba(245, 126, 42, 0.2);
        }
    }
    .action-btns {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        .details-btn {
            background-color: rgba(119, 119, 119, 0.18);
            color: ${({theme}) => theme?.light?.primary};
            padding: 10px;
            border-radius: 25px;
        }
    }
    .tabs {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 20px;
        max-width: 400px;
        margin-bottom: 30px;
    }
    .tabs strong {
        cursor: pointer;
        color: var(--gray);
        border-bottom: 2px solid transparent;
        padding-bottom: 4px;
        transition: color 0.3s, border-color 0.3s;
        font-weight: 500;
    }
    .tabs strong.active {
        color: ${({theme}) => theme?.light?.primary};
        border-bottom: 2px solid ${({theme}) => theme?.light?.primary};
    }

    .table-layout {
        border: none;
        box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.08);
        tbody {
            tr {
                border: 0;
            }
        }
    }
`;
export const ReportsHeaderWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 20px;

    @media (min-width: 992px) {
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
    }
    @media (min-width: 1200px) {
        gap: 20px;
    }

    .left-wrap {
        .title {
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            @media (min-width: 768px) {
                font-size: 18px;
                line-height: 22px;
            }
        }
    }
    .rightwrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        color: black;
        @media (min-width: 768px) {
            flex-direction: row;
            align-items: center;
        }
        @media (min-width: 992px) {
            width: auto;
        }
        @media (min-width: 1200px) {
            gap: 20px;
        }
        .date-wrap {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: black;
            @media (min-width: 992px) {
                width: auto;
            }
            @media (min-width: 1200px) {
                gap: 20px;
            }
            .date {
                width: 100%;

                @media (min-width: 992px) {
                    max-width: 140px;
                }
                input {
                    padding: 0 10px;
                }
            }
        }
        .right-content {
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 10px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: black;
            @media (min-width: 992px) {
                width: auto;
            }
            @media (min-width: 1200px) {
                gap: 20px;
            }
            form {
                flex-grow: 1;
            }
            button {
                background-color: ${({theme}) => theme?.light?.primary50};
                color: var(--black);
                @media (min-width: 991px) {
                    padding: 12px 24px;
                }
            }
        }
    }
`;
